/**
 * 🟦 V11.4 — Bridge alto-nivel para style inference.
 *
 * Orquesta: capturar imagen + computed styles, llamar al endpoint,
 * validar patches, devolver shape estable. Sin remount del iframe.
 */
import { captureNodeImage } from './captureNodeImage';
import { analyzeStyle } from './analyzeStyle';

function isValidPatch(p) {
  return p && typeof p === 'object'
    && ['replace', 'add', 'remove'].includes(p.op)
    && typeof p.path === 'string'
    && p.path.startsWith('/');
}

export function validatePatches(arr) {
  if (!Array.isArray(arr)) return [];
  return arr.filter(isValidPatch);
}

export async function inferStyleForNode(targetNode) {
  if (!targetNode || !targetNode.uib_id) {
    return { ok: false, error: 'no_target_node' };
  }
  const cap = await captureNodeImage(targetNode.uib_id);
  if (cap.error && !cap.computed_styles) {
    return { ok: false, error: cap.error };
  }
  try {
    const data = await analyzeStyle({
      imageB64: cap.imageB64 || null,
      computed_styles: cap.computed_styles || {},
      tag: targetNode.tag || 'div',
    });
    const patches = validatePatches(data.patches);
    if (patches.length === 0) {
      return { ok: false, error: 'no_valid_patches' };
    }
    return {
      ok: true,
      styleName: String(data.styleName || 'inferred-style').slice(0, 64),
      description: String(data.description || '').slice(0, 240),
      patches,
      source: data.source || 'llm',
      preview: cap.imageB64 || null,
    };
  } catch (e) {
    return { ok: false, error: e?.message || 'analyze_failed' };
  }
}
